import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import { isIndexableRoute } from "@/constants/indexingPolicy";

const RouteIndexingPolicy = () => {
  const { pathname } = useLocation();
  const robots = isIndexableRoute(pathname) ? "index, follow" : "noindex, nofollow";

  return (
    <Helmet>
      <meta name="robots" content={robots} />
      <meta name="googlebot" content={robots} />
    </Helmet>
  );
};

export default RouteIndexingPolicy;
